// Maputnik style editor, embedded via iframe inside the admin shell.
//
// Nginx serves the Maputnik static build at /editor/ (alias → /opt/maputnik/dist),
// gated with `auth_request /_authz` so direct access without a session cookie
// or a valid API key returns 401. Here we just frame it so it gains the same
// sidebar + header context as every other admin page, mirroring the Map page
// pattern. The route is `/style-editor` because `/editor` is owned by nginx.
export default function StyleEditor() {
  return (
    <iframe
      src="/editor/"
      title="Maputnik style editor"
      className="block h-full w-full border-0"
      allow="clipboard-read; clipboard-write"
    />
  );
}
